"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHeader = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.CardHeader = function (_a) {
    var _b = _a.small, small = _b === void 0 ? false : _b, children = _a.children, rest = tslib_1.__rest(_a, ["small", "children"]);
    return (react_1.default.createElement(StyledContainer, tslib_1.__assign({ small: small }, rest), children));
};
var StyledContainer = styled_components_1.default(function (_a) {
    var small = _a.small, rest = tslib_1.__rest(_a, ["small"]);
    return react_1.default.createElement("div", tslib_1.__assign({}, rest));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n  font-family: ", ";\n  font-size: 1.3rem;\n  line-height: 23px;\n"], ["\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n  font-family: ", ";\n  font-size: 1.3rem;\n  line-height: 23px;\n"])), function (_a) {
    var small = _a.small;
    return (small ? '0.8rem 2.4rem' : '1.6rem 2.4rem');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[100];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
});
var templateObject_1;
